import React, { useEffect, useState } from 'react';
import { teacherApi } from '../../api/client';
import Spinner from '../../components/common/Spinner';
import Modal from '../../components/common/Modal';
import { FaUpload, FaTrash, FaDownload, FaFilePdf } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Materials() {
  const [materials, setMaterials] = useState([]);
  const [grades,    setGrades]    = useState([]);
  const [subjects,  setSubjects]  = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [modal,     setModal]     = useState(false);
  const [gradeFilter, setGradeFilter] = useState('');
  const [form, setForm] = useState({ title:'', description:'', subject_id:'', grade_id:'' });
  const [file, setFile] = useState(null);

  const load = () => teacherApi.getMaterials({}).then(r=>setMaterials(r.data.data)).finally(()=>setLoading(false));
  useEffect(() => { Promise.all([teacherApi.getGrades(), teacherApi.getSubjects()]).then(([g,s])=>{ setGrades(g.data.data); setSubjects(s.data.data); }); load(); }, []); // eslint-disable-line

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) return toast.error('Please select a file');
    const fd = new FormData();
    Object.entries(form).forEach(([k,v])=>fd.append(k,v));
    fd.append('file', file);
    const token = localStorage.getItem('access_token');
    if (token) fd.append('_token', token);
    try { await teacherApi.uploadMaterial(fd); toast.success('Material uploaded'); setModal(false); setFile(null); load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const filtered = gradeFilter ? materials.filter(m=>String(m.grade_id)===gradeFilter) : materials;

  return (
    <div>
      <div className="page-header" style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
        <div><h2>Study Materials</h2><p>Upload and manage learning resources</p></div>
        <button className="sms-btn sms-btn-primary" onClick={()=>{setForm({title:'',description:'',subject_id:'',grade_id:''});setFile(null);setModal(true);}}><FaUpload size={13}/> Upload</button>
      </div>

      <div style={{marginBottom:16}}>
        <select className="sms-input" style={{width:200}} value={gradeFilter} onChange={e=>setGradeFilter(e.target.value)}>
          <option value="">All Grades</option>
          {grades.map(g=><option key={g.grade_id} value={g.grade_id}>Grade {g.grade_number}</option>)}
        </select>
      </div>

      {loading ? <Spinner /> : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))',gap:16}}>
          {filtered.map(m=>(
            <div key={m.id} className="sms-card-sm" style={{display:'flex',flexDirection:'column',gap:8}}>
              <div style={{display:'flex',alignItems:'center',gap:10}}>
                <div style={{width:40,height:40,borderRadius:8,background:'#fee2e2',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  <FaFilePdf color="#ef4444" size={18}/>
                </div>
                <div style={{overflow:'hidden'}}>
                  <div style={{fontWeight:600,fontSize:'0.9rem',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{m.title}</div>
                  <div style={{color:'#6b7280',fontSize:'0.78rem'}}>{m.subject_name} · Gr {m.grade_number}</div>
                </div>
              </div>
              {m.description && <p style={{color:'#4b5563',fontSize:'0.83rem',margin:0}}>{m.description}</p>}
              <div style={{color:'#9ca3af',fontSize:'0.75rem'}}>Uploaded {new Date(m.uploaded_at).toLocaleDateString()}</div>
              <div style={{display:'flex',gap:8}}>
                <a href={m.file_url} target="_blank" rel="noreferrer" className="sms-btn sms-btn-outline sms-btn-sm" style={{flex:1,justifyContent:'center'}}><FaDownload size={11}/> Download</a>
                <button className="sms-btn sms-btn-danger sms-btn-sm" onClick={async()=>{if(window.confirm('Delete?')){await teacherApi.deleteMaterial(m.id);toast.success('Deleted');load();}}}><FaTrash size={11}/></button>
              </div>
            </div>
          ))}
          {filtered.length===0&&<div style={{gridColumn:'1/-1',textAlign:'center',color:'#9ca3af',padding:'60px 0'}}>No materials uploaded yet</div>}
        </div>
      )}

      <Modal show={modal} onClose={()=>setModal(false)} title="Upload Study Material">
        <form onSubmit={handleUpload}>
          <div style={{marginBottom:14}}><label className="sms-label">Title <span style={{color:'#ef4444'}}>*</span></label><input className="sms-input" value={form.title} onChange={e=>setForm({...form,title:e.target.value})} required /></div>
          <div style={{marginBottom:14}}><label className="sms-label">Description</label><textarea className="sms-input" rows={2} value={form.description} onChange={e=>setForm({...form,description:e.target.value})} /></div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
            <div><label className="sms-label">Grade <span style={{color:'#ef4444'}}>*</span></label>
              <select className="sms-input" value={form.grade_id} onChange={e=>setForm({...form,grade_id:e.target.value})} required>
                <option value="">Select</option>{grades.map(g=><option key={g.grade_id} value={g.grade_id}>Grade {g.grade_number}</option>)}
              </select>
            </div>
            <div><label className="sms-label">Subject <span style={{color:'#ef4444'}}>*</span></label>
              <select className="sms-input" value={form.subject_id} onChange={e=>setForm({...form,subject_id:e.target.value})} required>
                <option value="">Select</option>{subjects.filter(s=>!form.grade_id||String(s.grade_id)===form.grade_id).map(s=><option key={s.subject_id} value={s.subject_id}>{s.subject_name}</option>)}
              </select>
            </div>
          </div>
          <div style={{marginBottom:20}}><label className="sms-label">File <span style={{color:'#ef4444'}}>*</span></label><input className="sms-input" type="file" accept=".pdf,.doc,.docx,.ppt,.pptx" onChange={e=>setFile(e.target.files[0])} required /></div>
          <div style={{display:'flex',gap:10}}>
            <button type="submit" className="sms-btn sms-btn-primary">Upload</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={()=>setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
